<template>
  <div class="scrolling-wrapper-flexbox">
    <slot></slot>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
.scrolling-wrapper-flexbox {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  & > * {
    flex: 0 0 auto;
  }
}
</style>
